import type { FeatureFlagsEnum } from '@omnea-app/packages/universal/feature-flags/featureFlags'

export const ARTEFACTS_AGENT_GATE = {
  orgFeatureFlag: 'TPRM',
  releaseFlag: 'RELEASE_ARTEFACTS_AGENT',
} as const satisfies { orgFeatureFlag: FeatureFlagsEnum; releaseFlag: string }
